import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { AppProvider } from "@/context/AppContext";

/**
 * Was jede Route über den Router hereingereicht bekommt.
 *
 * Der QueryClient steht hier, damit `beforeLoad` an dieselbe Sitzung kommt wie
 * die Oberfläche. Ohne ihn müsste der Guard selbst einen Request bauen und
 * hätte damit eine zweite, eigene Wahrheit über den Anmeldezustand.
 */
export type RouterContext = {
	readonly queryClient: QueryClient;
};

/**
 * Der AppProvider liegt an der Wurzel, nicht im geschützten Bereich: Er trägt
 * nur Prototyp-Zustand (Rollen-Umschalter, Hell/Dunkel, Mock-Benutzer) und
 * auch die öffentlichen Drehplan-Seiten sollen das Theme schalten können.
 * Echte, schützenswerte Daten laufen weiter über TanStack Query.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
	component: () => (
		<AppProvider>
			<Outlet />
		</AppProvider>
	),
});
